export const fadeDuration = 1.1
